import gql from 'graphql-tag';

export const CREATE_PRODUCT_REVIEW = gql`
  mutation CreateProductReview(
    $sku: ID!
    $email: String!
    $rating: Int!
    $comment: String!
    $title: String
  ) {
    createProductReview(
      sku: $sku
      email: $email
      rating: $rating
      comment: $comment
      title: $title
    ) {
      author {
        email
        publicDisplayName
      }
      rating
      comment
      title
      createdAt
    }
  }
`;

export const GET_PRODUCT_REVIEWS = gql`
  query GetProductReviews(
    $sku: ID!
    $orderCreatedAt: String
    $page: Int
    $itemsPerPage: Int
  ) {
    getProductReviews(
      sku: $sku
      orderCreatedAt: $orderCreatedAt
      page: $page
      itemsPerPage: $itemsPerPage
    ) {
      author {
        email
        publicDisplayName
      }
      rating
      comment
      title
      createdAt
    }
  }
`;

export const GET_PRODUCT_REVIEWS_BY_CUSTOMER = gql`
  query GetProductReviewsByCustomer($skus: [ID], $orderCreatedAt: String) {
    getProductReviewsByCustomer(skus: $skus, orderCreatedAt: $orderCreatedAt) {
      author {
        email
        publicDisplayName
      }
      rating
      comment
      title
      createdAt
      status
      reviewSubject {
        code
      }
    }
  }
`;
